import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faClock, faHourglassHalf, faRedo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BCol, BRow } from "bootstrap-vue";
import { computed, ref } from "vue";
import { useRouter } from "vue-router/composables";
import { fetchAllBroadcasts, updateBroadcast } from "@/api/notifications.broadcast";
import { Toast } from "@/composables/toast";
import {} from "@/stores/broadcastsStore";
import BroadcastCard from "./BroadcastCard.vue";
import Heading from "@/components/Common/Heading.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BroadcastsList',
    setup(__props) {
        library.add(faCheck, faClock, faHourglassHalf, faRedo);
        const router = useRouter();
        const overlay = ref(false);
        const loading = ref(false);
        const showActive = ref(true);
        const showExpired = ref(true);
        const showScheduled = ref(true);
        const broadcasts = ref([]);
        const filteredBroadcasts = computed(() => {
            return broadcasts.value.filter(filterBroadcasts);
        });
        const broadcastExpired = (item) => item.expiration_time && new Date(item.expiration_time) < new Date();
        function filterBroadcasts(item) {
            if (broadcastExpired(item)) {
                return showExpired.value;
            }
            if (broadcastPublished(item)) {
                return showActive.value;
            }
            return showScheduled.value;
        }
        function broadcastPublished(item) {
            return new Date(item.publication_time) < new Date();
        }
        function onEdit(item) {
            router.push(`/admin/notifications/edit_broadcast/${item.id}`);
        }
        async function onForceExpire(item) {
            await updateBroadcast(item.id, { expiration_time: new Date().toISOString().slice(0, 23) });
            await loadBroadcastsList(true);
            Toast.info("Broadcast marked as expired. It will be removed from the database in the next cleanup cycle.");
        }
        function onGoToLink(link) {
            if (link.startsWith("/")) {
                router.push(link);
            }
            else {
                window.open(link, "_blank");
            }
        }
        async function loadBroadcastsList(overlayLoading = false) {
            if (overlayLoading) {
                overlay.value = true;
            }
            else {
                loading.value = true;
            }
            try {
                broadcasts.value = await fetchAllBroadcasts();
                broadcasts.value.sort((a, b) => new Date(b.create_time).getTime() - new Date(a.create_time).getTime());
            }
            finally {
                loading.value = false;
                overlay.value = false;
            }
        }
        loadBroadcastsList();
        return { __sfc: true, router, overlay, loading, showActive, showExpired, showScheduled, broadcasts, filteredBroadcasts, broadcastExpired, filterBroadcasts, broadcastPublished, onEdit, onForceExpire, onGoToLink, loadBroadcastsList, faCheck, faClock, faHourglassHalf, faRedo, FontAwesomeIcon, BAlert, BButton, BCol, BRow, BroadcastCard, Heading, LoadingSpan };
    }
});
